export default "__VITE_ASSET__CfBa2ZL2__"